<template>
    <section>
        <img v-if="loading" class="image page-loading" src="@/assets/img/page-loading.gif" />
        <div v-else class="branding mb-6">
            <h1 class="mb-5">Branding</h1>
            <h3 class="mt-6">Logotype</h3>
            <p>Upload your logotype.</p>
            <div v-if="brand_logo.logo && brand_logo.preview === false" class="branding-logo mb-5">
                <img :src="brand_logo.logo" />
            </div>
            <div v-if="brand_logo.preview" class="branding-logo mb-5">
                <img :src="brand_logo.preview" />
            </div>
            <div class="branding-upload custom-file mb-5">
                <input @change="preview_logo($event)" type="file" accept="image/*" class="custom-file-input" id="customFile">
                <label class="custom-file-label" for="customFile">Choose logotype</label>
            </div>
            <button v-if="brand_logo.logo && brand_logo.preview === false" v-on:click="update_logo()" v-bind:class="{load: brand_logo.loading}" type="button" class="btn btn-primary d-block">
                Delete
                <div class="loading"></div>
            </button>
            <button v-if="brand_logo.preview" v-on:click="update_logo()" v-bind:class="{load: brand_logo.loading}" type="button" class="btn btn-primary d-block">
                Save
                <div class="loading"></div>
            </button>
            <h3 class="mt-6">Login Cover</h3>
            <p>Upload your login cover. This image is displayed at login.</p>
            <div v-if="brand_cover.cover && brand_cover.preview === false" v-bind:style="{backgroundImage: 'url(' + brand_cover.cover + ')'}" class="branding-cover mb-5"></div>
            <div v-if="brand_cover.preview" v-bind:style="{backgroundImage: 'url(' + brand_cover.preview + ')'}" class="branding-cover mb-5"></div>
            <div class="branding-upload custom-file mb-5">
                <input @change="preview_cover($event)" type="file" accept="image/*" class="custom-file-input" id="customFile">
                <label class="custom-file-label" for="customFile">Choose cover</label>
            </div>
            <button v-if="brand_cover.cover && brand_cover.preview === false" v-on:click="update_cover()" v-bind:class="{load: brand_cover.loading}" type="button" class="btn btn-primary d-block">
                Delete
                <div class="loading"></div>
            </button>
            <button v-if="brand_cover.preview" v-on:click="update_cover()" v-bind:class="{load: brand_cover.loading}" type="button" class="btn btn-primary d-block">
                Save
                <div class="loading"></div>
            </button>
        </div>
    </section>
</template>

<script>
    /* eslint-disable */
    export default {
        name: 'AccountBranding',
        metaInfo: {
            title: 'Branding'
        },
        data () {
            return {
                loading: false,
                brand_logo: {
                    logo: false,
                    preview: false,
                    upload_event: false,
                    loading: false
                },
                brand_cover: {
                    cover: false,
                    preview: false,
                    upload_event: false,
                    loading: false
                }
            }
        },
        mounted () {
            this.load_brand();
        },
        methods: {
            load_brand () {
                this.loading = true;
                axios.get(process.env.VUE_APP_API_URL + '/api/brand/')
                    .then(response => (
                        this.brand_logo.logo = response.data['brand_logo'],
                        this.brand_cover.cover = response.data['brand_login_cover'],
                        this.loading = false
                    ))
            },
            preview_logo(event) {
                this.upload_event = event;
                const logo = event.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(logo);
                reader.onload = e =>{
                    this.brand_logo.preview = e.target.result;
                };
            },
            update_logo() {
                this.brand_logo.loading = true;

                let data = new FormData();
                if (this.brand_logo.preview) {
                    data.append('logo', this.upload_event.target.files[0]);
                    data.append('filename', this.upload_event.target.files[0].name);
                }
                else {
                    data.append('logo', '');
                    data.append('filename', '');
                }

                axios.post(process.env.VUE_APP_API_URL + '/api/brand/logo/',
                    data,
                    {
                        headers: {
                            'Content-Type' : 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        this.brand_logo.loading = false,
                        location.reload()
                    })
            },
            preview_cover(event) {
                this.upload_event = event;
                const cover = event.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(cover);
                reader.onload = e =>{
                    this.brand_cover.preview = e.target.result;
                };
            },
            update_cover() {
                this.brand_cover.loading = true;

                let data = new FormData();
                if (this.brand_cover.preview) {
                    data.append('cover', this.upload_event.target.files[0]);
                    data.append('filename', this.upload_event.target.files[0].name);
                }
                else {
                    data.append('cover', '');
                    data.append('filename', '');
                }

                axios.post(process.env.VUE_APP_API_URL + '/api/brand/cover/',
                    data,
                    {
                        headers: {
                            'Content-Type' : 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        this.brand_cover.loading = false,
                        location.reload()
                    })
            }
        }
    }
</script>
